import React from "react";

import { FileInput, FileLabel, HostContainer } from "./file-upload-button.styles";
import { FileUploadButtonProps } from "./file-upload-button.props";

export const FileUploadButton = (props: FileUploadButtonProps) => {
  const { accept = "*/*" } = props;

  const onSelect = (event: any) => {
    if (event.target.files.length > 0) {
      props.onUpload(event.target.files[0]);
    }
  };

  return (
    <HostContainer>
      <FileLabel>
        Upload
        <FileInput accept={accept} name="attachment" type="file" onChange={onSelect} />
      </FileLabel>
    </HostContainer>
  );
};
